import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  Output,
  ViewChild,
  EventEmitter,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormBuilder } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { AbstractNgModelComponent } from 'src/app/components/base/abstract-ng-model/abstract-ng-model.component';
import { WorkorderApiService } from 'src/app/services/api/workorder-api.service';

@Component({
  selector: 'app-issue-category-select',
  templateUrl: './issue-category-select.component.html',
  styleUrls: ['./issue-category-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: IssueCategorySelectComponent,
    },
  ],
})
export class IssueCategorySelectComponent
  extends AbstractNgModelComponent
  implements OnChanges
{
  @ViewChild(MatMenuTrigger, { static: true, read: ElementRef })
  userMenu!: ElementRef<HTMLElement>;
  @Input() platform = '';
  @Input() problem: any;
  @Output() problemChange = new EventEmitter<any>();

  get userMenuData() {
    return {
      menuWidth: this.userMenu.nativeElement.clientWidth,
    };
  }

  value: any;

  isDropdownOpen = false;
  src = '../../../../../assets/images/workorder/Icon-down-arrow-min.svg';

  constructor(
    private elementRef: ElementRef,
    private api: WorkorderApiService,
  ) {
    super();
  }

  ngOnChanges(): void {
    this.findWorkProblems();
  }

  override writeValue(v: any): void {
    this.value = v;
    if (!this.value) {
      this.problem = null;
    }
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      this.src = '../../../../../assets/images/workorder/Icon-up-arrow-min.svg';
    } else {
      this.src =
        '../../../../../assets/images/workorder/Icon-down-arrow-min.svg';
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
      this.src =
        '../../../../../assets/images/workorder/Icon-down-arrow-min.svg';
    }
  }

  override onChange(): void {
    super.onChange();
  }

  selectOption(option: any) {
    this.isDropdownOpen = false;
    this.src = '../../../../../assets/images/workorder/Icon-down-arrow-min.svg';
    this.problem = option;
    this.value = this.problem.id;
    this.onChange();
    this.problemChange.emit(this.problem);
  }

  problems: any = [];
  loading = false;
  async findWorkProblems() {
    try {
      this.loading = true;
      const r = await this.api.findWorkProblems(
        this.platform,
        'InUse',
        'zh-CN',
        1,
        50,
      );
      this.problems = r.data.list;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
